export { default } from "bullitttime-embermodelsgochips/models/activator";
